// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"38a9539b","491":"cce79ab0","600":"16a94287"}[chunkId] + ".chunk.js";
};